// utils/randomString.js
export function generateRandomString(length = 10) {
  // Define allowed characters (exclude 1, i, 0, O, g, q)
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ' + // uppercase without I, O
                     'abcdefghjklmnpqrstuvwxyz' + // lowercase without i, g, q
                     '23456789';                 // numbers without 0, 1

  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters[randomIndex];
  }

  return result;
}